export default function isPlural(val) {
  if (val === 1) {
    return false
  } else {
    return true
  }
}
